import script from "./customer-table.vue?vue&type=script&lang=ts&setup=true"
export * from "./customer-table.vue?vue&type=script&lang=ts&setup=true"

import "./customer-table.vue?vue&type=style&index=0&id=2aa989eb&lang=scss&scoped=true"

import exportComponent from "/home/crmfront/lineCRM-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2aa989eb"]])

export default __exports__